import moment from 'moment';
import './App.css';
import AppRoutes from './routes/AppRoutes';
import "./services/intercerptor"
import 'moment/locale/sr';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  moment.locale('sr');
  return (
    <>
      <AppRoutes />
      <ToastContainer position="top-right" autoClose={3000} />
    </>

  );
}

export default App;
